import React, { CSSProperties, ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import styled, { Interpolation } from 'styled-components';

type Props = {
  id: string;
  text: ReactNode;
  btnText?: string;
  btnStyles?: Interpolation<CSSProperties>;
} & React.ComponentProps<typeof ReactTooltip>;

const TooltipButton = styled.span<{ styles?: Interpolation<CSSProperties> }>`
  display: inline-block;
  background: #bbb;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 50%;
  text-align: center;
  margin: 0 8px;
  font-size: 0.8rem;
  font-weight: 800;
  color: white;
  cursor: pointer;
  ${({ styles }) => styles}
`;

const Tooltip = ({
  id,
  text,
  btnText = '?',
  type = 'dark',
  place = 'right',
  btnStyles,
  ...rest
}: Props) => {
  return (
    <>
      <TooltipButton data-tip data-for={id} data-event="click focus" styles={btnStyles}>
        {btnText}
      </TooltipButton>
      <ReactTooltip
        id={id}
        type={type}
        place={place}
        effect="solid"
        globalEventOff="click"
        {...rest}
      >
        <span>{text}</span>
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
